/**
 * Lightweight key registry for webpage-customization sections.
 *
 * Kept free of any component/hook imports (unlike `Customization.constants.js`,
 * which builds the JSX config and therefore pulls in the whole Customizations
 * chunk). Low-level modules — the builder sidebar forms and the page-builder
 * postMessage bridges — must import from here: importing the heavy constants
 * file from them creates a circular chunk dependency and crashes webpack
 * module evaluation with a TDZ ReferenceError.
 */
export const CUSTOMIZATION_SECTIONKEYS = {
  BRAND_ASSETS: "brand_assets",
  WEBSITE_ADDRESS: "website_address",
  BRAND_LOGO: "brand_logo",
  TAB_TITLE: "hero_section_title",
  TAB_ICON: "tab_icon",
  COLOR_PALETTE: "color_palette",
  LEAD_CONTACT: "lead_contact",
  BOOKING_TNC: "tnc",
  MANAGE_BOOKING: "manage_booking",
  HIDE_GET_IN_TOUCH: "hide_get_in_touch_section",
  MANAGE_LEAD_CONTACT: "manage_lead_contact_form",
  MANAGE_EXIT_LEAD: "manage_exit_lead_capture_form",
  CUSTOM_TNC: "custom_t_c",
  PERSONAL_ADDRESS_TITLE: "personal_address_title",
  HIDE_CREATOR_ADDRESS: "show_creator_personal_address",
  HIDE_TRUST_MARKERS: "hide_trustmarker_icons",
  CREATOR_CONTACT_CTA_TEXT: "contact_creator_cta_text",
  SHARE_CTA_TEXT: "share_event_cta_text",
  MEET_CREATOR_HEADER: "meet_creator",
  CERTIFICATE_TITLE: "custom_certificate_title",
  PHONE_TITLE: "call_section_title",
  PHONE_DECRIPTION_TITLE: "call_section_description",
  VISIT_WEBSITE_CTA: "visit_website_cta",
  TRUST_MARKERS: "trust_markers",
  CUSTOM_FOOTER: "custom_footer",
  HIDE_FOOTER: "hide_footer",
  SHOW_LISTING_RATINGS: "show_listing_ratings",
};

// Copy shared by the Customizations config and the offerings sidebar toggle so
// the two entry points cannot drift.
export const SHOW_LISTING_RATINGS_COPY = {
  section_title: "Ratings & Reviews",
  section_description:
    "Show customer ratings on your offering cards to build trust and encourage bookings.",
  toggle_label: "Show ratings on offering cards",
  toggle_description:
    "When enabled, offering cards on your website will display the average star rating and review count (only for offerings that have received feedback).",
};
